import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { ReservedSpecialSku } from './reserved-special-sku';

@Injectable({
  providedIn: 'root',
})
export class SpecialsService {
  readonly serviceURL: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/specials';
  }

  getReservedSpecialSku(): Observable<ReservedSpecialSku> {
    return this.http.post<ReservedSpecialSku>(this.serviceURL, null);
  }
}
